import React, { Suspense } from "react";
import { Canvas, useLoader } from "@react-three/fiber";
import {
  ContactShadows,
  OrbitControls,
  /*useTexture*/ Sky,
} from "@react-three/drei";
import { TextureLoader } from "three/src/loaders/TextureLoader";

import "./index.css";

// All textures are CC0 textures from: https://cc0textures.com/
const name = (type) => `./textures/Seamless_Sample_${type}.jpg`;

function Scene() {
  const [albedoMap, aoMap, heightlMap, normalMap, roughnessMap] = useLoader(
    TextureLoader,
    [
      name("Albedo"),
      name("AO"),
      name("Height"),
      name("Normal"),
      name("Roughness"),
    ]
  );
  // const [
  //   colorMap,
  //   displacementMap,
  //   normalMap,
  //   roughnessMap,
  //   aoMap
  // ] = useTexture([
  //   name("Color"),
  //   name("Displacement"),
  //   name("Normal"),
  //   name("Roughness"),
  //   name("AmbientOcclusion")
  // ]);
  return (
    <>
      <ambientLight intensity={0.05} />
      <directionalLight />
      <mesh>
        {/* Width and height segments for displacementMap */}
        <sphereBufferGeometry args={[1, 100, 100]} />
        <meshStandardMaterial
          displacementScale={0.2}
          map={albedoMap}
          aoMap={aoMap}
          heightlMap={heightlMap}
          normalMap={normalMap}
          roughnessMap={roughnessMap}
        />
      </mesh>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 4], fov: 50 }}>
        <spotLight
          position={[10, 10, 10]}
          angle={0.15}
          penumbra={1}
          shadow-mapSize={[512, 512]}
          castShadow
        />

        <Suspense fallback={null}>
          <Scene />
          <OrbitControls autoRotate />
        </Suspense>

        <ContactShadows
          position={[0, -1.4, 0]}
          opacity={0.75}
          scale={10}
          blur={2.5}
          far={4}
        />
      </Canvas>
    </div>
  );
}
